import { useMemo } from "react"

import { useProductObjCache } from "entities/products/model/store/useProductObjCache"

interface ProductInformationWithAddons {
  variantKey: string
  addons?: Array<{
    productType: string
    title: string
    [key: string]: unknown
  }> | null
}

export function useEnrichedProductInformation<
  T extends ProductInformationWithAddons
>(productInformation: T | null | undefined): T | null | undefined {
  const { getCacheForVariantKey } = useProductObjCache()

  return useMemo(() => {
    if (!productInformation) return productInformation

    const enrichedAddons = productInformation.addons?.map(addon => ({
      ...addon,
      title:
        getCacheForVariantKey(productInformation.variantKey)?.addons?.[
          addon.productType
        ]?.title || addon.title
    }))

    return { ...productInformation, addons: enrichedAddons }
  }, [productInformation, getCacheForVariantKey])
}
